/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamRolePermission,
    IamRolePermissionFromJSON,
    IamRolePermissionFromJSONTyped,
    IamRolePermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateIamRolePermissionRequest
 */
export interface CreateIamRolePermissionRequest {
    /**
     * 
     * @type {IamRolePermission}
     * @memberof CreateIamRolePermissionRequest
     */
    iamRolePermission: IamRolePermission;
}

export function CreateIamRolePermissionRequestFromJSON(json: any): CreateIamRolePermissionRequest {
    return CreateIamRolePermissionRequestFromJSONTyped(json, false);
}

export function CreateIamRolePermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIamRolePermissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamRolePermission': IamRolePermissionFromJSON(json['iam_role_permission']),
    };
}

export function CreateIamRolePermissionRequestToJSON(value?: CreateIamRolePermissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_role_permission': IamRolePermissionToJSON(value.iamRolePermission),
    };
}


